<!-- Location -->
<!-- <mat-card class="box-bottom-padding-and-border"> -->
<div>
  <!-- <span><mat-icon>edit</mat-icon></span> -->
  <div fxLayout="column" fxLayoutAlign="center center">
    <!-- <mat-icon *ngIf="!eORbButtonSwitch" class="location-icon" (click)="setLocationClick()">place</mat-icon> -->
    <!-- <mat-icon *ngIf="isRorEbuttShow" class="edit-icon" (click)="eORbClick()">{{eORbButtonSwitch ? "edit" :
      "settings_backup_restore"}}</mat-icon> -->
    <form [formGroup]="locForm" (ngSubmit)="onSubmit()" style="max-width: 420px;">

      <!-- coords read only -->
      <div *ngIf="eORbButtonSwitch" fxLayout="column" fxLayoutGap="5px" fxLayoutAlign="center center">
        <div>{{location}}</div>
      </div>

      <!-- lat long dmm -->
      <div *ngIf="isLLDmm" fxLayout="row" fxLayoutAlign="center center">
        <mat-form-field class="mat-form-field-mid">
          <input #dmmLat matInput type="text" [patterns]="maskCustomPatterns" [showMaskTyped]="false"
            [specialCharacters]="maskSpecialCharacters" [dropSpecialCharacters]="false" autocomplete="off"
            class="field-input" [mask]="maskLatLLDmm" [placeholder]="'EXTERNAL_IP.LATITUDE'| translate"
            formControlName="latLLDmm" (input)="typingHandeling($event, 'dmmlat')"
            [@blinkError]="errTransLocDmmLat ? 'red' : 'noraml'">
        </mat-form-field>
        <div class="seperator"></div>
        <mat-form-field class="mat-form-field-mid">
          <input #dmmLong matInput type="text" [patterns]="maskCustomPatterns" [showMaskTyped]="false"
            [specialCharacters]="maskSpecialCharacters" [dropSpecialCharacters]="false" autocomplete="off"
            class="field-input" [mask]="maskLongLLDmm" [placeholder]="'EXTERNAL_IP.LONGITUDE'| translate"
            formControlName="longLLDmm" (input)="typingHandeling($event, 'dmmlong')"
            [@blinkError]="errTransLocDmmLong ? 'red' : 'noraml'">
        </mat-form-field>
      </div>

      <!-- lat long dms -->
      <div *ngIf="isLLDms" fxLayout="row" fxLayoutAlign="center center">
        <mat-form-field class="mat-form-field-big">
          <input #dmsLat matInput type="text" [patterns]="maskCustomPatterns" [showMaskTyped]="true"
            [specialCharacters]="maskSpecialCharacters" [dropSpecialCharacters]="false" autocomplete="off"
            class="field-input" [mask]="maskLatLLDms" [placeholder]="'EXTERNAL_IP.LATITUDE'| translate"
            formControlName="latLLDms" (input)="typingHandeling($event, 'dmslat')"
            [@blinkError]="errTransLocDmsLat ? 'red' : 'noraml'">
        </mat-form-field>
        <div class="seperator"></div>
        <mat-form-field class="mat-form-field-big">
          <input #dmsLong matInput type="text" [patterns]="maskCustomPatterns" [showMaskTyped]="true"
            [specialCharacters]="maskSpecialCharacters" [dropSpecialCharacters]="false" autocomplete="off"
            class="field-input" [mask]="maskLongLLDms" [placeholder]="'EXTERNAL_IP.LONGITUDE'| translate"
            formControlName="longLLDms" (input)="typingHandeling($event, 'dmslong')"
            [@blinkError]="errTransLocDmsLong ? 'red' : 'noraml'">
        </mat-form-field>
      </div>

      <!-- utm -->
      <div *ngIf="isUTM" fxLayout="row" fxLayoutAlign="center center">
        <mat-form-field class="mat-form-field-small">
          <input matInput type="text" [patterns]="maskCustomPatterns" [showMaskTyped]="false"
            [specialCharacters]="maskSpecialCharacters" [dropSpecialCharacters]="false" autocomplete="off"
            class="field-input" [mask]="maskZoneUTM" [placeholder]="'EXTERNAL_IP.ZONE'| translate"
            formControlName="zoneUTM" (input)="typingHandeling($event, 'utmzone')"
            [@blinkError]="errTransLocUtmZone ? 'red' : 'noraml'">
        </mat-form-field>
        <div class="seperator"></div>
        <mat-form-field class="mat-form-field-small">
          <input matInput type="text" [patterns]="maskCustomPatterns" [showMaskTyped]="false"
            [specialCharacters]="maskSpecialCharacters" [dropSpecialCharacters]="false" autocomplete="off"
            class="field-input" [mask]="maskEastingUTM" [placeholder]="'EXTERNAL_IP.EASTING'| translate"
            formControlName="eastingUTM" (input)="typingHandeling($event, 'utmeasing')"
            [@blinkError]="errTransLocUtmEast ? 'red' : 'noraml'">
        </mat-form-field>
        <div class="seperator"></div>
        <mat-form-field class="mat-form-field-small">
          <input matInput type="text" [patterns]="maskCustomPatterns" [showMaskTyped]="false"
            [specialCharacters]="maskSpecialCharacters" [dropSpecialCharacters]="false" autocomplete="off"
            class="field-input" [mask]="maskNorthingUTM" [placeholder]="'EXTERNAL_IP.LONGITUDE'| translate"
            formControlName="northingUTM" (input)="typingHandeling($event, 'utmnorthing')"
            [@blinkError]="errTransLocUtmNorth ? 'red' : 'noraml'">
        </mat-form-field>
      </div>
    </form>
    <div *ngIf="location != undefined && !eORbButtonSwitch" class="aro-label-under-input" [matTooltip]="'FIELDS.CURRENT_VALUE' | translate">
      {{location}}
    </div>
    <div class="aro-label-clickable" (click)="locationClick()">({{locUnits}})
    </div>
  </div>

  <button *ngIf="!eORbButtonSwitch"
    [ngClass]="eORbButtonSwitch ? 'small-button-coords-left-r' : 'small-button-coords-left-e'" mat-stroked-button
    (click)="setLocationClick()">
    <mat-icon class="svg-icon">place</mat-icon>
  </button>

  <button *ngIf="isRorEbuttShow"
    [ngClass]="eORbButtonSwitch ? 'small-button-coords-right-r' : 'small-button-coords-right-e'" mat-stroked-button
    (click)="eORbClick()">
    <mat-icon class="svg-icon">{{eORbButtonSwitch ? "edit" :
      "settings_backup_restore"}}</mat-icon>
  </button>
</div>